import { useEffect, useState } from "react"
import { SettingsGroup } from "../../../Modules/General"
import * as Basic from "../../../Modules/BasicFields"
import FontModule from "../../../Modules/FontModule"

export default function ABTesting( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const selected = props.selected
    const reset = props.reset

    const [ exprA, setExprA ] = useState(null)
    const [ exprB, setExprB ] = useState(null)

    const [ font, setFont ] = useState(null)


    const requiredData = [
        exprA,
        exprB,
        font
    ]

    const cfgName = "pulse_ab_testing_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setExprA( cfg.expr_a || "" )
        setExprB( cfg.expr_b || "" )
        setFont( cfg.font || {})
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}
        data.expr_a = exprA 
        data.expr_b = exprB
        data.font = font

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ exprA, exprB, font ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <> 
            <SettingsGroup name="Behaviour">
                <Basic.StringInput name="Expression A" value={exprA} setValue={setExprA}/>
                <Basic.StringInput name="Expression B" value={exprB} setValue={setExprB}/>
            </SettingsGroup>
            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
        </>

    )
}
